import React, { useEffect, useState } from "react";
import "./NavMenu.scss";
import { getHomeBoardList } from "@Components/Header/services/Header.service";
import { APIStatus } from "@Services/baseInterfaces";
import { useNavigate, useLocation } from "react-router-dom";
import { filterEvents, FILTER_EVENTS } from "@Src/utils/events/filterEvents";

export default function NavMenu({ onClose }) {
  const navigation = useNavigate();
  const location = useLocation();
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await getHomeBoardList();
        if (response && response.ResponseType === APIStatus.SUCCESS && response.data) {
          setMenuItems([...response.data,
          { Id: "who-are-we", Name: "About iAbhyas" }
          ]);
        } else {
          // Fallback or default items if API fails
          setMenuItems([
            { Id: "who-are-we", Name: "About iAbhyas" }
          ]);
        }
      } catch (error) {
        console.error("Error fetching menu items:", error);
        setMenuItems([
          { Id: "who-are-we", Name: "About iAbhyas" }
        ]);
      }
    };

    fetchMenuItems();
  }, []);

  const handleNavigation = (item) => {
    // Emit event to reset keyword search in all filters
    filterEvents.emit(FILTER_EVENTS.RESET_KEYWORD);

    if (item.Id === "who-are-we") {

      window.location.href = `${process.env.REACT_APP_MAIN_SITE_URL}/who-are-we`

    } else {
      navigation(`/board/${item.Id}/${item.Name}`);
    }
    if (onClose) onClose();
  };

  return (
    <nav className="">
      <ul className="headerNav flex tw-items-center tw-justify-center">
        {menuItems.map((item, index) => {
          // Check if current path matches this board or who-are-we page
          const isActive = (item.Id === "who-are-we" && location.pathname === '/who-are-we') ||
            (item.Id !== "who-are-we" && location.pathname.startsWith(`/board/${item.Id}/`));

          return (
            <li key={item.Id || index} className="flex tw-items-center" onClick={(e) => {
              e.preventDefault();
              handleNavigation(item);
            }
            }>
              <a
                className={`cursor-pointer ${isActive ? 'active' : ''}`}
                href={item.Id === "who-are-we" ? '/who-are-we' : `/board/${item.Id}/${item.Name}`}

              >
                {item.Name}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
